import type {FilterChip} from '@/modules/common/hooks/useFilterChips';

import {LabelSmallSemibold, Stack} from '@travel-frontend/ui-components';
import {useTranslation} from 'react-i18next';

import {CountBadge} from '@/components/CountBadge';
import {FilterChips} from '@/modules/common/components/FilterChips';
import {testId} from '@/utils/testId';

type Props = {
  filterChips: Array<FilterChip>;
  onClickFilter?: () => void;
  onClickReset?: () => void;
};

export const ActiveFilters: React.FunctionComponent<Props> = ({
  filterChips,
  onClickFilter,
  onClickReset,
}) => {
  const {t} = useTranslation('filters');

  return (
    <Stack>
      <LabelSmallSemibold data-testid={testId('applied-filters')}>
        {t('chips.activeFilters')} <CountBadge count={filterChips.length} />
      </LabelSmallSemibold>
      <FilterChips
        filterChips={filterChips}
        onClickChip={onClickFilter}
        onClickReset={onClickReset}
      />
    </Stack>
  );
};
